export const isStaging =
  window.location.hostname.includes("stanza-testing.com");
export const isLocal =
  window.location.hostname.includes("localhost") ||
  window.location.hostname.includes("127.0.0.1");
